import { FC } from 'react';
import { cx } from '@emotion/css';
import { useTranslation } from 'next-i18next';

import { ProductDetails, ProductListItem } from '@phoenix/team-m/my-tool-shed/frontend/util/product/product.model';
import { ToolInfoLabeledMark } from './tool-info-labeled-mark';

interface ToolInfoLabeledMarksProps {
  product?: ProductListItem | ProductDetails;
  isLoading?: boolean;
  className?: string;
}

export const ToolInfoLabeledMarks: FC<ToolInfoLabeledMarksProps> = ({ product = {} as ProductDetails, isLoading = false, className }) => {
  const { t } = useTranslation();
  const { isVerifiedIMow, warrantyExtensionDate } = product || {};

  return !isLoading && (isVerifiedIMow || warrantyExtensionDate) ? (
    <span className={cx('flex flex-col gap-2', className)}>
      {warrantyExtensionDate && (
        <ToolInfoLabeledMark
          id="warrantyExtensionMark"
          icon="icon-shield-16.svg"
          labels={[t('toolShed_overview_listItem_label_warrantyExtension_active')]}
        />
      )}
      {isVerifiedIMow && (
        <ToolInfoLabeledMark
          id="iMowVerifiedMark"
          icon="icon-note-check-16.svg"
          labels={[t('toolShed_overview_listItem_label_verified'), t('toolShed_overview_listItem_label_verified_text_addedInApp')]}
        />
      )}
    </span>
  ) : null;
};
